import axios from '../Axios/Default';
import { handleResponse } from '../Utils/Utils';

export const getRegionAll = (_params, onSuccess, onError) => {
    const response = axios.get('v1/admin/region', { params: _params });
    return handleResponse(response, onSuccess, onError);
};

export const getRegionById = (id, onSuccess, onError) => {
    const response = axios.get(`v1/admin/region/${id}`);
    return handleResponse(response, onSuccess, onError);
};

export const createRegion = (payload, onSuccess, onError) => {
    const response = axios.post(`v1/admin/region`, payload);
    return handleResponse(response, onSuccess, onError);
};

export const updateRegion = (id, payload, onSuccess, onError) => {
    const response = axios.put(`v1/admin/region/${id}`, payload);
    return handleResponse(response, onSuccess, onError);
};

export const softDeleteRegion = (id, payload, onSuccess, onError) => {
    const response = axios.put(`v1/admin/region/${id}/delete`, payload);
    return handleResponse(response, onSuccess, onError);
};

export const deleteRegion = (id, onSuccess, onError) => {
    const response = axios.delete(`v1/admin/region/${id}`);
    return handleResponse(response, onSuccess, onError);
};